import { isPlainDatatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';

export const ConditionOperatorInType = createConditionOperator({
  code: 'in',
  label: 'in',
  description: 'È uno di',
  args: [
    {
      type: 'referenceValue',
      isArray: true,
    },
  ],
  allowsField: field => isPlainDatatype(field.type),
  compare(value: any, [list]: [any[]]) {
    if (list == null) return false;
    return list.includes(value);
  },
});
